module.exports = __webpack_public_path__ + "static/sismica2-72e328367ac7fc2a832d361238544a2d.jpg";